export const getReminders = (state) => state.reminders;
